<template>
  <v-container fluid class="inventoryjournal-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs color="primary">
          <v-tab v-if="initvalue.journalstatus=='New'" :href="`#tab-journal`" class="mr-5">
            <v-icon class="mr-3">mdi-text-box-outline</v-icon>
            Journal
          </v-tab>
          <!-- <v-tab v-if="initvalue.journalstatus=='New'" class="mr-5" :href="`#tab-details`" >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Items
          </v-tab> -->
          <v-tab-item :value="'tab-journal'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Inventory Journal</p>
                      <v-select
                        class="mb-4"
                        :items="['Inventory Journal']"
                        v-model="initvalue.journaltype"
                        v-on:change="onChangeJournal($event, 'journaltype')"
                        v-bind:error="errorindex == 0"
                        outlined
                        dense
                        placeholder="Type"
                        persistent-hint
                        single-line
                        hint="Please choose the journal type"
                      >
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="['Inventory Adjustment', 'Inventory Transfer']"
                        v-model="initvalue.journalsubtype"
                        v-on:change="onChangeJournal($event, 'journalsubtype')"
                        v-bind:error="errorindex == 0"
                        outlined
                        dense
                        placeholder="Subtype"
                        persistent-hint
                        single-line
                        hint="Please choose the journal subtype"
                      >
                      </v-select>
                      <v-text-field
                        readonly
                        outlined
                        dense
                        v-model="journaldate"
                        label="Journal Date"
                        v-bind:value="journaldate"
                        v-on:change="
                          onChangeJournal($event, 'journaldate')
                        "
                        v-bind:error="errorindex == 1"
                        single-line
                        hint="Please choose the journal date"
                      >
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        v-model="initvalue.journalname"
                        v-on:change="
                          onChangeJournal($event, 'journalname')
                        "
                        outlined
                        v-bind:error="errorindex == 11"
                        dense
                        placeholder="Journal Name"
                        persistent-hint
                        single-line
                        hint="Enter the journal name"
                      >
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items="locations.map(x => {return {text: x.locationname, value: x._id};})"
                        v-model="initvalue.locationid"
                        v-on:change="onChangeJournal($event, 'locationid')"
                        v-bind:error="errorindex == 6"
                        outlined
                        dense
                        placeholder="Location"
                        persistent-hint
                        single-line hint="Please choose the location">
                      </v-select>
                      <v-textarea
                        v-model="initvalue.journalnote"
                        v-on:change="onChangeJournal($event, 'journalnote')"
                        outlined
                        rows=3
                        label="Note"
                        hint="please enter the note"
                      ></v-textarea>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/inventoryjournal/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        :loading="isReceiving"
                        class="button-shadow"
                        color="primary"
                        @click="updateInventoryJournal()"
                      >
                        Save
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-details'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <p class="text-h5">Items</p>
                    <v-form>
                      <v-row justify="center">
                        <v-col md="2">
                          <v-select
                            class="mb-4"
                            :items="
                              brands.filter(brand=>brand.brandtype=='Brand').map((x) => {
                                return { text: x.brandname, value: x._id };
                              })
                            "
                            v-model="newTransaction.brandid"
                            v-bind:error="errorindex == 2"
                            v-on:change="populateItems"
                            outlined
                            dense
                            placeholder="Brand"
                            persistent-hint
                            single-line
                            hint="Brand"
                          >
                          </v-select>
                        </v-col>
                        <v-col md="3">
                          <v-select
                            class="mb-4"
                            :items="newTransaction.branditems"
                            v-model="newTransaction.itemid"
                            v-bind:error="errorindex == 0"
                            v-on:change="populatePriceField"
                            outlined
                            dense
                            placeholder="Item"
                            persistent-hint
                            single-line
                            hint="Item"
                          >
                          </v-select>
                        </v-col>
                        <v-col md="1">
                          <v-select
                            class="mb-4"
                            :items="['', 'Foc', 'Promo']"
                            v-model="newTransaction.itemfoc"
                            outlined
                            dense
                            placeholder="Free"
                            persistent-hint
                            single-line
                            hint="Free"
                          >
                          </v-select>
                        </v-col>
                        <v-col md="1">
                          <v-text-field
                            v-model="newTransaction.itemquantity"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Qty"
                            persistent-hint
                            type="number"
                            v-on:input="calculateAmount"
                            oninput="if(this.value < 0) this.value = 0;"
                            single-line
                            hint="Quantity"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col md="2">
                          <v-text-field
                            v-model="newTransaction.itemprice"
                            v-on:input="calculateAmount"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Prc"
                            persistent-hint
                            single-line
                            hint="Price"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col md="2">
                          <v-text-field
                            readonly
                            v-model="newTransaction.itemamount"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Amt"
                            persistent-hint
                            single-line
                            hint="Amount"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col md="1">
                          <v-btn
                            class="button-shadow"
                            color="success"
                            @click="insertTransaction()"
                          >
                            Add
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-data-table
                        :headers="transactionHeaders"
                        :items="transactions"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteTransaction" width="500">
                            <v-card>
                              <v-card-title> Delete this Item? </v-card-title>
                              <v-card-text>
                                {{ deletetransaction.itemname }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteTransaction = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteTransaction(deletetransaction)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.itemimage="{ item }">
                          <v-img
                            v-bind:lazy-src="item.itemimage"
                            min-width="50"
                            max-width="100"
                            v-bind:src="item.itemimage"
                          ></v-img>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="loadEditTransaction(item)"
                          >
                            <v-icon>mdi-pencil-outline</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteTransactionDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/inventoryjournal/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          
          
          
        </v-tabs>
      </v-col>
    </v-row>
    <div class="text-center">
      
      
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatStdDate } from '@/mixins/date';
import router from "@/Routes";

export default {
  data() {
    return {
      transactionHeaders: [
        { text: "Image", value: "itemimage" },
        { text: "Name", value: "itemname" },
        { text: "Foc", value: "itemfoc" },
        { text: "Qty", value: "itemquantity" },
        { text: "Prc", value: "itemprice" },
        { text: "Amount", value: "itemamount" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      fileHeaders: [
        { text: "Type", value: "filetype" },
        { text: "Name", value: "filename" },
        { text: "Size", value: "filesize" },
        { text: "Created", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],

      edit_journal: {},
      deletetransaction: {},
      deletefile: {},
      trade: {},
      searchcustomer: {},
      initvalue: {},
      editTransaction: {branditems:[]},
      newTransaction: {branditems:[]},
      upload: {filename: null,file: null},
      files: [],
      images: [],
      branditems: [],
      transactions: [],


      filename: null,
      uploadname: null,

      route: 0,
      isEditTransaction: false,
      isUploadFile: false,
      brandid: undefined,
      price: undefined,

      itemimage: undefined,
      itemid: undefined,
      itemname: undefined,
      itemquantity: 1,
      itemfoc: undefined,
      itemprice: undefined,
      itemamount: undefined,
      itemcategoryid: undefined,
      itemsubcategoryid: undefined,
      
      journaldate: null,
      journalpostdate: null,
      etddate: null,
      etadate: null,
      menu_journaldate: false,
      menu_journalpostdate: false,
      menu_etddate: false,
      menu_etadate: false,

      isDeleteFile: false,
      isTrade: false,
      isDeleteTransaction: false,    
      errorindex: undefined,
    };
  },
  computed: {
    ...mapState("Brand", ["brands"]),
    ...mapState("Customer", ["customers"]),
    ...mapState("Item", ["items"]),
    ...mapState("Location", ["locations"]),
    ...mapState("PayMethod", ["paymethods"]),
    ...mapState("Price", ["prices"]),
    ...mapState("PriceList", ["pricelists"]),
    ...mapState("Region", ["regions"]),
    ...mapState("Township", ["townships"]),
    ...mapState("InventoryJournal", ["isReceiving"]),
    ...mapState("User", ["users"]),
  },
  methods: {
    ...mapActions("Brand", ["getBrandsRequest"]),
    ...mapActions("Customer", ["getCustomersRequest"]),
    ...mapActions("File", ["insertInventoryJournalFile", "deleteFileRequest", "getInventoryJournalFiles"]),
    ...mapActions("Item", ["getItemsRequest"]),
    ...mapActions("Location", ["getLocationsRequest"]),
    ...mapActions("PayMethod", ["getPayMethodsRequest"]),
    ...mapActions("Price", ["getPricesRequest"]),
    ...mapActions("PriceList", ["getPriceListsRequest"]),
    ...mapActions("Region", ["getRegionsRequest"]),
    ...mapActions("InventoryJournal", ["deleteSOTransactionRequest", "getInventoryJournalsRequest", "insertSOTransactionRequest", "updateInventoryJournalRequest",]),
    ...mapActions("Township", ["getTownshipsRequest"]),
    ...mapActions("User", ["getUsersRequest"]),
    checkError() {
      if (!this.accessname) {
        this.errorindex = 0;
        return false;
      }
      if (!this.accesspath) {
        this.errorindex = 1;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    calculateAmount() {
      if(this.route==0)this.newTransaction.itemamount = this.newTransaction.itemquantity * this.newTransaction.itemprice;
      else if(this.route==1)this.editTransaction.itemamount = this.editTransaction.itemquantity * this.editTransaction.itemprice;
      this.itemamount = this.editTransaction.itemamount;  
    },
    calculateTotal() {
      if(!this.transactions) return;
      
    },
    clearTransaction() {
      this.editTransaction = {branditems:[]};
      this.newTransaction = {branditems:[]};
    },
    deleteTransactionDialog(item) {
      this.isDeleteTransaction = true;
      this.deletetransaction = {_id: item._id, itemname: item.itemname, itemquantity: item.itemquantity};
    },
    deleteFileDialog(item) {
      this.isDeleteFile = true;
      this.deletefile = {_id: item._id,filename: item.filename,};
    },
    async deleteFile(payload) {
      this.isDeleteFile = false;
      let response = await this.deleteFileRequest(payload);
      let index = this.files.findIndex((trans) => trans._id == response._id);
      this.files.splice(index, 1);
    },
    async deleteTransaction(payload) {
      this.isDeleteTransaction = false;
      let response = await this.deleteSOTransactionRequest(payload);
      let index = this.transactions.findIndex((trans) => trans._id == response._id);
      this.transactions.splice(index, 1);
      this.calculateTotal();
      this.getInventoryJournalsRequest();
    },
    async insertTransaction() {
      let payload = {
        journalid: this.initvalue._id,
        brandid: this.newTransaction.brandid,
        itemid: this.newTransaction.itemid,
        itemimage: this.newTransaction.itemimage,
        itemname: this.newTransaction.itemname,
        itemquantity: this.newTransaction.itemquantity,
        itemfoc: this.newTransaction.itemfoc,
        itemprice: this.newTransaction.itemprice,
        itemamount: this.newTransaction.itemamount,
        itemcategoryid: this.newTransaction.itemcategoryid,
        itemsubcategoryid: this.newTransaction.itemsubcategoryid,
      };
      let response = await this.insertSOTransactionRequest(payload);
      this.transactions.push(response);
      this.calculateTotal();
      this.clearTransaction();
    },
    loadEditTransaction(item) {
      console.log(item);
      this.route = 1;
      this.isEditTransaction = !this.isEditTransaction;
      this.editTransaction._id = item._id;
      this.editTransaction.brandid = item.brandid;
      this.populateItems(item.brandid);
      this.editTransaction.itemid = item.itemid;
      this.editTransaction.itemimage = item.itemimage;
      this.editTransaction.itemname = item.itemname;
      this.editTransaction.itemquantity = item.itemquantity;
      if (this.editTransaction.itemfoc == "foc") this.editTransaction.itemprice = 0; 
      else this.editTransaction.itemprice = item.itemprice;

      this.editTransaction.itemfoc = item.itemfoc;
      this.editTransaction.itemamount = item.itemamount;
      this.itemamount = this.editTransaction.itemamount;
      this.editTransaction.itemcategoryid = this.items.find(x=>x._id==item.itemid).itemcategoryid;
      this.editTransaction.itemsubcategoryid = this.items.find(x=>x._id==item.itemid).itemsubcategoryid;
    },
    onChangeFile(file) {
      if (!file) this.upload.file = null;
      else this.upload.file = file;
    },
    onChangeJournal(value, field) {
      this.edit_journal[field] = value;
    },
    onChangeTrade(value, field) {
      this.trade[field] = value;
    },
    onUploadChange(file) {
      if (!file) {return;}
      this.upload.itemimage = file;
      this.upload.imagename = file.name;
    },
    populateCustomerFields(customerid) {
      var customer = this.customers.find((customer) => customer._id == customerid);
      this.edit_journal.journalname = customer.customername;
      this.edit_journal.journaladdress = customer.customeraddress;
      this.edit_journal.journalphone = customer.customerphone;
      this.edit_journal.journalmobile = customer.customermobile;
      this.edit_journal.townshipid = customer.townshipid;
      this.edit_journal.pricelistid = customer.pricelistid;
    },
    populateItems(brandid) {
      console.log(this.route, brandid)
      let branditems = this.items.filter((item) => item.brandid == brandid);
      if(this.route==0) this.newTransaction.branditems = branditems.map((x) => {return { text: x.itemname, value: x._id }});
      else if(this.route==1) this.editTransaction.branditems = branditems.map((x) => {return { text: x.itemname, value: x._id }});
    },
    populatePriceField(itemid) {
      let price = this.prices.find((price) =>price.itemid == itemid && price.pricelistid == this.initvalue.pricelistid);
      let item = this.items.find((item) => item._id == itemid);
      if(this.route==0){
        this.newTransaction = Object.assign(this.newTransaction, item);
        this.newTransaction.itemname = item.itemsalesdesc;
        this.newTransaction.itemprice = price.listprice;
      }
      else if(this.route==1){
        this.editTransaction = Object.assign({},item);
        this.editTransaction.itemprice = price.listprice;
      }
      this.calculateAmount();
    },

    searchCustomerDialog(){
      this.searchcustomer = {};
      this.isSearchCustomer = true;
    },
    


    async updateInventoryJournal() {
      this.edit_journal._id = this.initvalue._id;
      await this.updateInventoryJournalRequest(this.edit_journal);
      router.push("/inventoryjournal/list");
    },
    async updateTransaction() {
      this.isEditTransaction = false;
      console.log(this.editTransaction)
      let response = await this.updateInventoryJournalTransaction(this.editTransaction);
      let index = this.transactions.findIndex((x) => x._id == response._id);
      this.transactions.splice(index, 1, response);
      this.calculateTotal();
      this.clearTransaction();
      this.getInventoryJournalsRequest();
    },
    async uploadFile(){
      this.upload.journalid = this.initvalue._id;
      this.isUploadFile = false;
      let file = await this.insertInventoryJournalFile(this.upload);
      this.files.push(file);
      this.upload = {filename: null,file: null};
    },
  },

  async created() {
    this.initvalue = this.$route.params;
    if (!this.initvalue._id) this.$router.push({ name: "InventoryJournalList" });
    this.journaldate = formatStdDate(this.initvalue.journaldate);
    
    if (this.items.length==0) await this.getItemsRequest();
    if (this.locations.length==0) await this.getLocationsRequest();
    
    this.files = this.initvalue.files;
    this.images = this.initvalue.images;
    this.transactions = this.initvalue.transactions;
    this.calculateTotal();
  },
};
</script>

<style src="./Edit.scss" lang="scss"></style>
